import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {AuthenticationService} from '../_services/authentication.service';
import {KeycloakService} from 'keycloak-angular';


// FIXME: Voir pour gérer les erreurs 403 et passer les rôles dans les requêtes pour pouvoir rediriger directement
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private keycloakService: KeycloakService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      return next.handle(request).pipe(catchError(err => {
        console.error(err);
        console.error(err.GraphError);
          if (err.status === 401 || err.status === 403) {
              // auto logout if 401 response returned from api
            console.error('error interceptor 401');
            this.keycloakService.updateToken(1).then((isUpdated) => {
              // On essai d'update le token
              console.error('update token in ErrorInterceptor', isUpdated);
            });
          }

          const error = err.error.message || err.statusText;
          return throwError(error);
      }));
    }
}
